import React, { FC } from 'react';

interface IProps {
  iconWithBorder?: boolean;
}

const IconVerticalThreeDots: FC<IProps> = ({ iconWithBorder = true }) => {
  return (
    <>
      {iconWithBorder ? (
        <svg
          width="21"
          height="24"
          viewBox="0 0 21 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="20" height="23" rx="7.5" stroke="#262528" />
          <path
            d="M12 12C12 11.175 11.325 10.5 10.5 10.5C9.675 10.5 9 11.175 9 12C9 12.825 9.675 13.5 10.5 13.5C11.325 13.5 12 12.825 12 12ZM12 16.5C12 15.675 11.325 15 10.5 15C9.675 15 9 15.675 9 16.5C9 17.325 9.675 18 10.5 18C11.325 18 12 17.325 12 16.5ZM12 7.5C12 6.675 11.325 6 10.5 6C9.675 6 9 6.675 9 7.5C9 8.325 9.675 9 10.5 9C11.325 9 12 8.325 12 7.5Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="4"
          height="18"
          viewBox="0 0 4 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 9C4 7.83125 3.1 6.875 2 6.875C0.899999 6.875 -1.27413e-06 7.83125 -1.32522e-06 9C-1.37631e-06 10.1687 0.899999 11.125 2 11.125C3.1 11.125 4 10.1687 4 9ZM4 15.375C4 14.2062 3.1 13.25 2 13.25C0.899999 13.25 -1.55279e-06 14.2062 -1.60388e-06 15.375C-1.65497e-06 16.5437 0.899999 17.5 2 17.5C3.1 17.5 4 16.5437 4 15.375ZM4 2.625C4 1.45625 3.1 0.5 2 0.5C0.899999 0.5 -9.95473e-07 1.45625 -1.04656e-06 2.625C-1.09765e-06 3.79375 0.899999 4.75 2 4.75C3.1 4.75 4 3.79375 4 2.625Z"
            fill="#959595"
          />
        </svg>
      )}
    </>
  );
};
export default IconVerticalThreeDots;
